import {recordSchema} from '@lightweightform/storage';
import {intermediarySchema} from './intermediary-form/intermediary-form.schema';

/**
 * App schema.
 */
export const appSchema = recordSchema({
  'intermediary-form': intermediarySchema
});
